module.exports = __webpack_public_path__ + "assets/webgl/FloorPattern.jpg.dxt.0272cbc4.ktx";